// Typelizer digest d8db29bebacacf6b2edf51869b5d3a3d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /up */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/up', {}, options),
    method: 'get',
  }),
}
